/**
 * Platform operator session. The access token (root token or per-operator
 * token) is held in sessionStorage and attached as `Authorization: Bearer` by
 * the API client; the backend verifies it server-side on every request.
 */

export interface PlatformPrincipal {
  operatorId: string | null;
  email: string;
  role: "super_admin" | "support";
}

const TOKEN_KEY = "jod.platform.token";
const PRINCIPAL_KEY = "jod.platform.principal";

function storage(): Storage | null {
  return typeof window === "undefined" ? null : window.sessionStorage;
}

export function getPlatformToken(): string | undefined {
  return storage()?.getItem(TOKEN_KEY) ?? undefined;
}

export function signInPlatform(token: string, principal: PlatformPrincipal): void {
  storage()?.setItem(TOKEN_KEY, token);
  storage()?.setItem(PRINCIPAL_KEY, JSON.stringify(principal));
}

export function signOutPlatform(): void {
  storage()?.removeItem(TOKEN_KEY);
  storage()?.removeItem(PRINCIPAL_KEY);
}

export function getPlatformPrincipal(): PlatformPrincipal | null {
  const raw = storage()?.getItem(PRINCIPAL_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PlatformPrincipal;
  } catch {
    return null;
  }
}
